import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, Chip, makeStyles, Typography } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import clsx from 'clsx';
import { pxToRem } from '../../theme';
const useStyles = makeStyles((theme) => ({
    card: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        boxShadow: 'none',
        maxWidth: '378px',
        position: 'relative',
        padding: theme.spacing(3),
        width: '100%',
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    cardActive: {
        cursor: 'pointer',
    },
    cardFullWidth: {
        maxWidth: 'none',
    },
    header: {
        alignItems: 'flex-start',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    enabledText: {
        alignItems: 'center',
        color: theme.palette.success.main,
        display: 'flex',
        fontSize: pxToRem(13),
        fontWeight: 600,
        lineHeight: pxToRem(22),
        letterSpacing: 0.46,
    },
    checkIcon: {
        marginLeft: theme.spacing(1.5),
        fontSize: pxToRem(18),
    },
    iconContainer: {
        alignItems: 'center',
        color: theme.palette.primary.main,
        display: 'flex',
        height: pxToRem(50),
        justifyContent: 'center',
        width: pxToRem(50),
    },
    title: {
        marginBottom: theme.spacing(1),
        fontSize: pxToRem(18),
        fontWeight: 500,
    },
    description: {
        color: theme.palette.text.secondary,
        fontSize: '14px',
        lineHeight: 1.5,
        marginBottom: theme.spacing(2),
        maxHeight: '64px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',
        lineClamp: 3,
    },
    categoryChip: {
        backgroundColor: theme.palette.brand.sky50,
        color: theme.palette.text.primary,
        height: pxToRem(32),
        fontSize: pxToRem(14),
    },
}));
export const IntegrationCard = ({ category, description, enabled, fullWidth, icon, onClick, title, testId, className, }) => {
    const classes = useStyles();
    return (_jsxs(Card, { className: clsx(classes.card, onClick && classes.cardActive, fullWidth && classes.cardFullWidth, className && className), onClick: onClick, "data-testid": testId, children: [_jsxs("div", { className: classes.header, children: [_jsx("div", { className: classes.iconContainer, children: icon }), enabled && (_jsxs(Typography, { className: classes.enabledText, children: ["Enabled ", _jsx(CheckCircleOutlineIcon, { className: classes.checkIcon })] }))] }), _jsxs(CardContent, { className: clsx(classes.cardContent, 'integration-card-content'), children: [_jsx(Typography, { className: classes.title, variant: 'h3', children: title }), _jsx(Typography, { className: classes.description, variant: 'body1', children: description }), _jsx(Box, { mt: 1, children: _jsx(Chip, { label: category, className: classes.categoryChip, size: 'medium' }) })] })] }));
};
